import { render, staticRenderFns } from "./StallTradeTable.vue?vue&type=template&id=60abe27f&scoped=true&"
import script from "./StallTradeTable.vue?vue&type=script&lang=js&"
export * from "./StallTradeTable.vue?vue&type=script&lang=js&"
import style0 from "./StallTradeTable.vue?vue&type=style&index=0&id=60abe27f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abe27f",
  null
  
)

export default component.exports